import AppButton from "../../../element/button/AppButton";
import React, {useEffect, useRef, useState} from "react";
import {PostFieldConfigItem} from "../../../../ts/manager/config/PostFieldConfig";
import SimpleChoice from "../../../../ts/common/SimpleChoiceVO";
import RouteChoice from "../../../../ts/model-factory/basic/route/RouteChoice";
import {getManager} from "../../../../ts/manager/Manager";
import {PostStatus, PostType} from "../../../../ts/manager/post/PostManager";
import {PostDataModel} from "../../../../ts/data/subject/PostDataFactory";
import CardDeckView from "../../../partial/snippet/CardDeckView";
import PostMapView from "./PostMapView";
import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import {idToSlug, multiNationalAlphabetic, slugToID} from "../../../../ts/common/SiteHelper";
import {IAnyObject} from "../../../../ts/common/SimpleInterface";
import {NICounties, NICounty} from "../../../../ts/manager/GeneralManager";
import eventBus from "../../../../ts/event/EventBus";

interface IProps
{
    routeProps:IRouteProps
    postType: PostType;
    routeChoiceList:RouteChoice[];
    postModel:PostDataModel
    hideMap?:boolean;
    hideCounties?:boolean;
    validPostStatuses?:PostStatus[]|null;
    allowInvalid?: boolean;
}

const PostListView = (props:IProps) =>
{
    const postType= props.postType;
    const [showPostStatusDropdown, setShowPostStatusDropdown] = useState<boolean>(false);
    const [showCategoryDropdown, setShowCategoryDropdown] = useState<boolean>(false);
    const [showCountyDropdown, setShowCountyDropdown] = useState<boolean>(false);
    const [showMap, setShowMap] = useState<boolean>(false);

    const postConfig = getManager().post.config[postType];
    const postFields = getManager().post.postFieldConfig[postType];

    const [, setSimpleState] = useState<any[]>([]);
    const searchFilterRef = useRef<HTMLIonInputElement|null>(null);

    const onDropdownSelected= () => {
        setSimpleState([]);
        setShowPostStatusDropdown(false)
        setShowCategoryDropdown(false)
        setShowCountyDropdown(false)
    }
    const assignedCategories:PostFieldConfigItem|null = postFields.items.assigned_categories ?? null;

    const knownParams = getManager().navigation.model.knownParams;
    let selectedPostStatus:PostStatus|null = (knownParams["post_status"] ?? null) as PostStatus|null;
    const queryCategory = knownParams["category"] ?? null;
    let queryCounty = !props.hideCounties ? (knownParams["county"] ?? null) : null;
    queryCounty = queryCounty ? slugToID(queryCounty) : null;

    const selectedCategory:SimpleChoice|null = queryCategory ? (assignedCategories?.choices[queryCategory] ?? null) : null;
    const selectedCounty:NICounty|null = NICounties.includes(queryCounty as NICounty) ? queryCounty as NICounty : null;

    const searchFiler:HTMLIonInputElement|null = searchFilterRef.current;
    const searchValue = searchFiler?.value ? multiNationalAlphabetic(searchFiler.value.toString(), true, null, true) : "";

    const routeChoiceList:RouteChoice[] = [];

    const validPostStatuses = props.validPostStatuses ?? ["publish"]

    useEffect(() =>
    {

        const onBaseClick = (event: CustomEvent) => {
            const htmlElement:HTMLElement|null = event.detail.htmlElement ?? null;
            const dropdownButton:HTMLButtonElement|null = (htmlElement?.closest(".dropdown")?.getElementsByTagName("button") ?? [])[0] ?? null;
            const buttonID = dropdownButton?.id ?? null;
            if(showPostStatusDropdown && (buttonID !== "filterPostStatusDropdown")){
                setShowPostStatusDropdown(false);
            } else if(showCategoryDropdown && (buttonID !== "filterCategoryDropdown")){
                setShowCategoryDropdown(false);
            } else if(showCountyDropdown && (buttonID !== "filterCountyDropdown")){
                setShowCountyDropdown(false);
            }
        }


        eventBus.on("site.base-click", onBaseClick);

        return () =>
        {
            eventBus.remove("site.base-click", onBaseClick);
        };
    }, [showPostStatusDropdown, showCategoryDropdown, showCountyDropdown]);

    const activePostStatuses:PostStatus[] = [];
    const categoryIDs:string[] = [];
    const counties:NICounty[] = [];
    for(let routeChoice of props.routeChoiceList){
        const choice = props.postModel.choices[routeChoice.id];
        if(!choice){
            continue;
        }
        if(!choice.lngLat && !props.allowInvalid){
            continue;
        }
        if(!validPostStatuses.includes(choice.postStatus)){
            continue
        }
        if(!activePostStatuses.includes(choice.postStatus)){
            activePostStatuses.push(choice.postStatus)
        }
        routeChoiceList.push(routeChoice)
    }
    activePostStatuses.sort((a, b) => {
        return validPostStatuses.indexOf(a) < validPostStatuses.indexOf(b) ? -1 : 1;
    })
    const visiblePostStatuses = activePostStatuses.slice();
    if(!visiblePostStatuses.includes("publish")){
        visiblePostStatuses.splice( visiblePostStatuses.indexOf("pending") === -1 ? 0 : 1, 0, "publish" );
    }
    selectedPostStatus = selectedPostStatus && visiblePostStatuses.includes(selectedPostStatus) ? selectedPostStatus : (activePostStatuses[0] ?? null);

    let filterableCount = 0;
    for(let i = 0; i < routeChoiceList.length; i ++){
        const routeChoice = routeChoiceList[i];
        let valid = true;

        const choice = props.postModel.choices[routeChoice.id];
        if(choice.postStatus !== selectedPostStatus){
            valid = false;
        }
        if(valid){

            for(let category of choice.categories){
                const categoryID = category.id.toString();
                if(!categoryIDs.includes(categoryID)){
                    categoryIDs.push(categoryID)
                }
            }
            if(selectedCategory){
                valid = false;
                for(let category of choice.categories){
                    if(category.id === selectedCategory.id){
                        valid = true;
                        break
                    }
                }
            }
        }
        if(valid && !props.hideCounties){
            if(!counties.includes(choice.addressVO.niCounty)){
                counties.push(choice.addressVO.niCounty)
            }
            if(selectedCounty){
                valid = choice.addressVO.niCounty === selectedCounty;
            }
        }
        if(valid){
            filterableCount ++;
        }
        if(valid && searchValue && !choice.searchString.includes(searchValue)){
            const parentChoice = choice.getParentChoice();
            if(!parentChoice || !parentChoice.simpleSearchString.includes(searchValue)){
                valid = false;
            }
        }
        if(!valid){
            routeChoiceList.splice(i, 1);
            i --;
        }
    }

    const categoryChoiceList = assignedCategories?.choiceList.slice() ?? [];
    for(let i = 0; i < categoryChoiceList.length; i++){
        const category = categoryChoiceList[i];
        const categoryID = category.id.toString();
        if(!categoryIDs.includes(categoryID)){
            categoryChoiceList.splice(i, 1);
            i --;
        }
    }
    const countyChoiceList:SimpleChoice[] = [];
    for(let county of NICounties){
        if(counties.includes(county)){
            countyChoiceList.push(getManager().general.counties[county]);
        }
    }

    const getPostStatusHref = (postStatus:PostStatus) => {
        const params:IAnyObject = {};
        if(postStatus !== activePostStatuses[0]){
            params.post_status = postStatus;
        }
        return getManager().navigation.model.constructQueryHref(params);
    }

    const getCategoryHref = (categoryID?:string) => {

        const params:IAnyObject = {}
        if(selectedPostStatus !== activePostStatuses[0]){
            params.post_status = selectedPostStatus;
        }
        if(categoryID){
            params.category = categoryID;
        }
        return getManager().navigation.model.constructQueryHref(params);
    }

    const getCountyHref = (county?:string) => {
        const params:IAnyObject = {}
        if(selectedPostStatus !== activePostStatuses[0]){
            params.post_status = selectedPostStatus;
        }
        if(selectedCategory){
            params.category = selectedCategory.id;
        }
        if(county){
            params.county = idToSlug(county);
        }
        return getManager().navigation.model.constructQueryHref(params);
    }

    return <section className="content-block set-bg-white">
        <div className="container">

            {((visiblePostStatuses.length > 1) || (categoryChoiceList.length > 1) || (counties.length > 1)) && <>
                <fieldset className="filters-box mt-4 mb-5" id="filterPostList">
                    <legend>Filters</legend>

                    <div className="row d-flex align-items-end g-4">

                        {(visiblePostStatuses.length > 1) && <>
                            <div className="col-12 col-lg-4">

                                <label htmlFor="filterPostStatusDropdown" className="filter-label">Post Status</label>

                                <div className="dropdown">

                                    <AppButton
                                        className={"btn btn-secondary dropdown-toggle " + (showPostStatusDropdown ? "show" : "")}
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        id="filterPostStatusDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded={showPostStatusDropdown ? "true" : "false"}
                                        onClick={() =>
                                        {
                                            setShowPostStatusDropdown(!showPostStatusDropdown)
                                        }
                                        }
                                    >
                                        {getManager().post.postStatusNames[selectedPostStatus]}
                                    </AppButton>

                                    <ul className={"dropdown-menu stay-on-page-dropdown-menu " + (showPostStatusDropdown ? "show" : "")} aria-labelledby="filterPostStatusDropdown">


                                        {(visiblePostStatuses).map((postStatus, index) =>

                                            <li
                                                key={index}
                                            >
                                                <AppButton
                                                    className="dropdown-item"
                                                    href={getPostStatusHref(postStatus)}
                                                    onClick={() => onDropdownSelected()}
                                                >
                                                    {getManager().post.postStatusNames[postStatus]}
                                                </AppButton>
                                            </li>
                                        )}


                                    </ul>
                                </div>
                            </div>
                        </>}

                        {(categoryChoiceList.length > 1) && <>
                            <div className="col-12 col-lg-4">

                                <label htmlFor="filterCategoryDropdown" className="filter-label">Category</label>

                                <div className="dropdown">

                                    <AppButton
                                        className={"btn btn-secondary dropdown-toggle " + (showCategoryDropdown ? "show" : "")}
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        id="filterCategoryDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded={showCategoryDropdown ? "true" : "false"}
                                        onClick={() =>
                                        {
                                            setShowCategoryDropdown(!showCategoryDropdown)
                                        }}
                                    >
                                        {!selectedCategory ? "Filter By Category:" : selectedCategory.name}
                                    </AppButton>

                                    <ul className={"dropdown-menu stay-on-page-dropdown-menu " + (showCategoryDropdown ? "show" : "")} aria-labelledby="filterCategoryDropdown">

                                        <li>
                                            <AppButton
                                                className="dropdown-item"
                                                href={getCategoryHref()}
                                                onClick={() => onDropdownSelected()}
                                            >
                                                View All
                                            </AppButton>
                                        </li>

                                        {(categoryChoiceList).map((category, index) =>

                                            <li
                                                key={index}
                                            >
                                                <AppButton
                                                    className="dropdown-item"
                                                    href={getCategoryHref(category.id.toString())}
                                                    onClick={() => onDropdownSelected()}
                                                >
                                                    {category.name}
                                                </AppButton>
                                            </li>
                                        )}


                                    </ul>
                                </div>
                            </div>
                        </>}

                        {(counties.length > 1) && <>
                            <div className="col-12 col-lg-4">

                                <label htmlFor="filterCountyDropdown" className="filter-label">County</label>

                                <div className="dropdown">

                                    <AppButton
                                        className={"btn btn-secondary dropdown-toggle " + (showCountyDropdown ? "show" : "")}
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        id="filterCountyDropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded={showCountyDropdown ? "true" : "false"}
                                        onClick={() =>
                                        {
                                            setShowCountyDropdown(!showCountyDropdown)
                                        }}
                                    >
                                        {!selectedCounty ? "Filter By County:" : getManager().general.counties[selectedCounty].name}
                                    </AppButton>


                                    <ul className={"dropdown-menu stay-on-page-dropdown-menu " + (showCountyDropdown ? "show" : "")} aria-labelledby="filterCountyDropdown">

                                        <li>
                                            <AppButton
                                                className="dropdown-item"
                                                href={getCountyHref()}
                                                onClick={() => onDropdownSelected()}
                                            >
                                                View All
                                            </AppButton>
                                        </li>

                                        {(countyChoiceList).map((countyChoice, index) =>

                                            <li
                                                key={index}>
                                                <AppButton
                                                    className="dropdown-item"
                                                    href={getCountyHref(countyChoice.id.toString())}
                                                    onClick={() => onDropdownSelected()}
                                                >
                                                    {countyChoice.name}
                                                </AppButton>
                                            </li>
                                        )}


                                    </ul>
                                </div>
                            </div>
                        </>}

                        <div className="col-12 col-lg-4 text-lg-end filter-results" id="page-counter-results">
                            {routeChoiceList.length} {routeChoiceList.length !== 1 ? postConfig.plural : postConfig.name}
                        </div>


                    </div>

                </fieldset>
            </>}

            <div id="listingsGroupContainer" className="row">
                <div className="col">

                    {!!routeChoiceList.length && <>
                        {!props.hideMap && <>
                            <nav className="responsive-tabs" id="listMapNav" aria-label="List or Map">
                                <ul className="nav nav-tabs responsive-tabs-container" id="inPageNavTabs" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <AppButton
                                            className={"nav-link " + (!showMap ? "active" : "")}
                                            id="list-view-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#list-view"
                                            type="button"
                                            role="tab"
                                            aria-controls="list-view"
                                            aria-selected={showMap ? "true" : "false"}
                                            onClick={() => setShowMap(false)}
                                        >
                                            <span
                                                className="is-fa fa-classic fa-regular fa-list"
                                                aria-hidden="true"
                                            ></span>
                                            List View
                                        </AppButton>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <AppButton
                                            className={"nav-link reveal-map " + (showMap ? "active" : "")}
                                            id="map-view-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#map-view"
                                            type="button"
                                            role="tab"
                                            aria-controls="map-view"
                                            data-reveal-id="mapListTabContent"
                                            tabIndex={-1}
                                            aria-selected={!showMap ? "true" : "false"}
                                            onClick={() => setShowMap(true)}
                                        >
                                            <span
                                                className="is-fa fa-classic fa-regular fa-map-location"
                                                aria-hidden="true"
                                            >
                                            </span>
                                            Map View
                                        </AppButton>
                                    </li>
                                </ul>
                            </nav>
                        </>}

                        <div className="tab-content" id="mapListTabContent">
                            <div className={"tab-pane fade pt-3 " + (!showMap ? "show active" : "")} id="list-view"
                                 role="tabpanel"
                                 aria-labelledby="list-view-tab">
                                <div id="listingsGroup" className="listings-group repopulate-map-on-change my-4">
                                    <CardDeckView
                                        routeChoiceList={routeChoiceList}
                                        useID="listingsPageListings"
                                        margin="mb-4"
                                    />
                                </div>
                            </div>
                            <div className={"tab-pane fade pt-5 " + (showMap ? "show active" : "")} id="map-view"
                                 role="tabpanel" aria-labelledby="map-view-tab">
                                <PostMapView
                                    routeProps={props.routeProps}
                                    routeChoiceList={routeChoiceList}
                                />
                            </div>
                        </div>
                    </>}
                    {!routeChoiceList.length && <>
                        <div id="no-results">
                            <h4>No {postConfig.plural.toLowerCase()} found</h4>
                            <p>There were no matching {postConfig.plural.toLowerCase()} found.</p>
                            <p>You should try adjusting your filters.</p>
                        </div>
                    </>}
                </div>
            </div>
        </div>
    </section>
}
export default PostListView;